import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp, Menu, X } from "lucide-react";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import { FaBox } from "react-icons/fa";
import { IoPricetagsSharp } from "react-icons/io5";
import { MdBorderColor } from "react-icons/md";
import "./Admintop.css";

const AdminTopNavbar = () => {
  const [openSections, setOpenSections] = useState({
    productManagement: false,
    category: false,
  });

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navRef = useRef();

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      productManagement: section === "productManagement" ? !prev.productManagement : false,
      category: section === "category" ? !prev.category : false,
    }));
  };

  const handleClickOutside = (e) => {
    if (navRef.current && !navRef.current.contains(e.target)) {
      setOpenSections({ productManagement: false, category: false });
      setIsMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      style={{
        backgroundImage:
          "linear-gradient(45deg, rgba(198, 219, 244, 0.5), rgb(218, 224, 248), rgb(198, 238, 178))",
      }}
    >
      <div className="top-navbar fixed-navbar" ref={navRef}>
        {/* Mobile Menu Toggle Button */}
        <div className="mobile-menu-toggle" style={{ display: 'none', padding: '10px' }}>
          <button
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
            }}
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        <div
          className="navcontent"
          style={{
            display: isMobileMenuOpen ? "flex" : "",
            flexDirection: isMobileMenuOpen ? "column" : "",
          }}
        >
          {/* Dashboard */}
          <div className="nav-section">
            <a href="/AdminDashBoard" className="nav-link">
              <RiDashboardHorizontalFill className="icon" /> Dashboard
            </a>
          </div>

          {/* Product Management */}
          <div className="nav-section">
            <button
              onClick={() => toggleSection("productManagement")}
              className="nav-link"
            >
              <FaBox className="icon" />
              Product Management
              {openSections.productManagement ? <ChevronUp /> : <ChevronDown />}
            </button>
            {openSections.productManagement && (
              <div className="dropdown-content">
                <a href="/Product">Add Product</a>
                <a href="/stockmanagement">Manage Products</a>
              </div>
            )}
          </div>

          {/* Category */}
          <div className="nav-section">
            <button
              onClick={() => toggleSection("category")}
              className="nav-link"
            >
              <IoPricetagsSharp className="icon" />
              Category
              {openSections.category ? <ChevronUp /> : <ChevronDown />}
            </button>
            {openSections.category && (
              <div className="dropdown-content">
                <a href="/Category">Add Category</a>
                <a href="/EditCategory">Edit Category</a>
              </div>
            )}
          </div>

          {/* Orders */}
          <div className="nav-section">
            <a href="/AdminOrders" className="nav-link">
              <MdBorderColor className="icon" /> Order Management
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTopNavbar;
